import { render, staticRenderFns } from "./pickarea.vue?vue&type=template&id=40fb5dde&"
import script from "./pickarea.vue?vue&type=script&lang=js&"
export * from "./pickarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports